import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Grid,
  Typography
} from '@mui/material';

export default function SchedulePicker({ onConfirm, onCancel }) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const handleConfirm = () => {
    if (!date || !time) {
      alert('Please select both date and time');
      return;
    }

    const scheduledAt = new Date(`${date}T${time}`);
    const now = new Date();

    if (scheduledAt <= now) {
      alert('Scheduled time must be in the future');
      return;
    }

    onConfirm(scheduledAt.toISOString());
  };

  // Set minimum date to today
  const today = new Date().toISOString().split('T')[0];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mb: 3 }}>
        Choose when to send this campaign or post
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type="date"
            label="Date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: today }}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            type="time"
            label="Time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            InputLabelProps={{ shrink: true }}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirm}>
              Schedule
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
